<template>
    <ul>
        <li>
            <a href="#" target="_self">
                <img src="https://interval-strasbourg.eu.dev.esilab.fr/site/wp-content/uploads/2023/01/placeholder-image.png" alt="Image de l'article">
            </a>
            <div>
                <a href="#" target="_self">Un projet de digitalisation de votre activité, site internet ou e-commerce ?</a>
                <p><span>24 janvier 2023</span><span>Catégorie</span></p>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        entreprise: Object,
    },
    data() {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
ul {
    width: 100%;
    height: auto;
    margin: 25px 0;
    padding: 0;
    list-style: none;
  li {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    a {
        img {
            width: 130px;
            height: auto;
            margin: 0;
            padding: 0;
            border-radius: 5px;
        }
    }
    div {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        a {
            margin: 0 0 15px 0;
            padding: 0;
            color: var(--black);
            font-size: 14px;
            font-weight: 700;
            text-decoration: none;
            background-color: initial;
            &:hover {
                color: var(--green);
            }
        }
        p {
            margin: 0;
            padding: 0;
            color: rgba(29, 29, 27, 0.6);
            font-size: 14px;
            font-weight: 500;
            span:last-child {
                margin-left: 15px;
                padding-left: 15px;
                border-left: solid 1px var(--black);
            }
        }
    }
  }
}
</style>